export default "__VITE_ASSET__102ae0f9__"